module.exports = __webpack_public_path__ + "static/nau-web-title.59e21651.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/nau-web-title.woff2
// module id = 282
// module chunks = 114276838955818